import React, { useState } from "react";
import "./BuildingAgeRateForm.css";
import { jsPDF } from "jspdf";

const BuildingAgeRateForm = () => {
  const [form, setForm] = useState({
    ageRange: "",
    zopadiRate: "",
    rccRate: ""
  });

  const [editId, setEditId] = useState(null);

  const [data, setData] = useState([
    { id: 1, ageRange: "0 TO 2", zopadiRate: 0.95, rccRate: 1.0 },
    { id: 2, ageRange: "2 TO 5", zopadiRate: 0.90, rccRate: 0.95 },
    { id: 3, ageRange: "5 TO 10", zopadiRate: 0.85, rccRate: 0.90 },
    { id: 4, ageRange: "10 TO 20", zopadiRate: 0.75, rccRate: 0.80 },
    { id: 5, ageRange: "20 TO 30", zopadiRate: 0.60, rccRate: 0.65 },
  ]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.ageRange || !form.zopadiRate || !form.rccRate) {
      alert("सर्व माहिती भरणे आवश्यक आहे");
      return;
    }

    if (editId) {
      // Edit mode
      setData(data.map((item) =>
        item.id === editId
          ? { ...item, ageRange: form.ageRange, zopadiRate: form.zopadiRate, rccRate: form.rccRate }
          : item
      ));
      alert("माहिती सफलतेने अपडेट झाली! ✅");
      setEditId(null);
    } else {
      // Add new
      setData([...data, { id: Date.now(), ageRange: form.ageRange, zopadiRate: form.zopadiRate, rccRate: form.rccRate }]);
      alert("माहिती यशस्वीरित्या जतन झाली! ✅");
    }

    setForm({ ageRange: "", zopadiRate: "", rccRate: "" });
  };

  const handleReset = () => {
    setForm({ ageRange: "", zopadiRate: "", rccRate: "" });
    setEditId(null);
  };

  const deleteData = (id) => {
    if (window.confirm("हटवायचं आहे का?")) {
      setData(data.filter((item) => item.id !== id));
      if (editId === id) {
        setEditId(null);
        setForm({ ageRange: "", zopadiRate: "", rccRate: "" });
      }
    }
  };

  const editData = (item) => {
    setForm({ ageRange: item.ageRange, zopadiRate: item.zopadiRate, rccRate: item.rccRate });
    setEditId(item.id);
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("इमारत वयोमान दर", pageWidth / 2, 10, { align: "center" });
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      const exportData = specificId 
        ? data.filter(item => item.id === specificId)
        : data;
      
      const tableData = exportData.map((item, index) => [
        index + 1,
        item.ageRange,
        item.zopadiRate,
        item.rccRate
      ]);
      
      pdf.autoTable({
        head: [["अ.क्र.", "वयोमान", "झोपडी/दगड", "विटा/आर.सी.सी"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 11
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      const fileName = specificId ? `वयोमान-दर-${specificId}.pdf` : `वयोमान-दर-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  return (
    <div className="building-age-rate-container">
      <div className="header">इमारत वयोमान दर</div>

      <div className="wrapper">
        <div className="box">
          {editId && (
            <div className="edit-mode-banner">
              ✏️ संपादन मोड (ID: {editId})
            </div>
          )}

          <div className="field">
            <label>
              वयोमान <span className="required">*</span>
            </label>
            <select
              name="ageRange"
              value={form.ageRange}
              onChange={handleChange}
            >
              <option value="">-- निवडा --</option>
              <option value="0 TO 2">0 TO 2</option>
              <option value="2 TO 5">2 TO 5</option>
              <option value="5 TO 10">5 TO 10</option>
              <option value="10 TO 20">10 TO 20</option>
              <option value="20 TO 30">20 TO 30</option>
              <option value="30 TO 40">30 TO 40</option>
              <option value="40 TO 50">40 TO 50</option>
              <option value="50 TO 60">50 TO 60</option>
              <option value="60 Plus">60 Plus</option>
            </select>
          </div>

          <div className="field">
            <label>
              झोपडी / दगड <span className="required">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="zopadiRate"
              value={form.zopadiRate}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <div className="field">
            <label>
              विटा / आर.सी.सी <span className="required">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="rccRate"
              value={form.rccRate}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <div className="btn-area">
            <button className="btn btn-save" onClick={handleSubmit}>
              जतन करा
            </button>
            <button className="btn btn-reset" onClick={handleReset}>
              रीसेट करा
            </button>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">इमारत वयोमान दर यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
            {data.length > 0 && (
              <button 
                className="btn-pdf-specific" 
                onClick={() => {
                  if (editId) {
                    generatePDF(editId);
                  } else {
                    alert("कृपया संपादित करायचा रेकॉर्ड निवडा");
                  }
                }}
              >
                📋 विशिष्ट PDF
              </button>
            )}
          </div>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>अ.क्र.</th>
              <th>वयोमान</th>
              <th>झोपडी / दगड</th>
              <th>विटा / आर.सी.सी</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id} className={editId === item.id ? "edit-row" : ""}>
                  <td>{index + 1}</td>
                  <td>{item.ageRange}</td>
                  <td>{item.zopadiRate}</td>
                  <td>{item.rccRate}</td>
                  <td className="action-btns">
                    <button
                      className="btn-edit"
                      onClick={() => editData(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => deleteData(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-data">कोणती माहिती उपलब्ध नाही</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BuildingAgeRateForm;
